import React, { useEffect } from 'react';
import { Button } from 'reactstrap';
import { IoClose } from 'react-icons/io5';

function Slidebar(props) {
  // Use the useEffect hook to add the event listener
  useEffect(() => {
    const handleOutsideClick = (event) => {
      // Check if the clicked element is outside the slidingBar
      if (props.openSidebar && !event.target.closest('.slidingBar')) {
        props.handleClose();
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [props.openSidebar, props.handleClose]);

  return (
    <>
      <div className={props.openSidebar ? 'slidingBar slide-left' : 'slidingBar hide'} style={props.style}>
        <div className="slide-header bg-transparent p-0">
          <ul className="nav nav-underline">
            <li className="nav-item">
              <a className="nav-link">{props.title}</a>
            </li>
            <li className="nav-item ms-auto me-2 d-flex align-items-center">
              <IoClose className="btn btn-close" onClick={props.handleClose} />
            </li>
          </ul>
        </div>
        <div className="slideBarContent">{props.content}</div>
        <div className="slideBarFooter">
          <div className="buttonsWrap ButtonComponent">
            <Button color="primary" className="btn btn-primary" type="submit" style={{ borderRadius: '8px', marginRight: '8px' }} onClick={props.handleSubmit}>
              Submit
            </Button>
            <Button color="secondary" className="btn cancelbtn" onClick={props.handleClose} style={{ borderRadius: '8px' }}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Slidebar;
